import o from"styled-components";const e=o.div`
	position: relative;
	background: url(${({imageUrl:o})=>o});
	background-size: cover;
	background-position: ${({position:o})=>o?`${o.x}% ${o.y}%`:"center"};
	border-radius: ${({borderRadius:o})=>`${o}px`};
	display: flex;
	flex-direction: column;
	gap: 6px;
	height: ${({shouldChangeHeight:o})=>o?"240px":"280px"};
	justify-content: flex-end;
	padding: 12px 14px;
	overflow: hidden;
	box-sizing: border-box;

	&::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 50%;
		background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
		pointer-events: none;
		z-index: 1;
		border-bottom-left-radius: ${({borderRadius:o})=>`${o}px`};
		border-bottom-right-radius: ${({borderRadius:o})=>`${o}px`};
	}
`,i=o.div`
	background-color: black;
	position: absolute;
	inset: 0;
	opacity: ${({opacity:o})=>o};
`,t=o.h1`
	margin: 0;
	font-size: 22px;
	color: white;
	font-weight: 500;
	z-index: 2;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,r=o.p`
	margin: 0;
	font-size: 14px;
	line-height: 18px;
	color: #ffffff;
	white-space: pre-wrap;
	z-index: 2;
	opacity: 0.6;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`;export{e as CardContainer,t as CardHeading,i as CardOverlay,r as CardParagraph};
